import { render, staticRenderFns } from "./ResumeStats.vue?vue&type=template&id=532ee289&scoped=true&"
import script from "./ResumeStats.vue?vue&type=script&lang=js&"
export * from "./ResumeStats.vue?vue&type=script&lang=js&"
import style0 from "./ResumeStats.vue?vue&type=style&index=0&id=532ee289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ee289",
  null
  
)

export default component.exports